/* ===========================================================================
   ROCKSOLAR product page — assets/rs-product.js
   ---------------------------------------------------------------------------
   Two jobs, both optional, both silent when there is nothing to do:

   1. Specification tabs. When custom.product_specification holds two or more
      tables, each headed by a component name in its first cell, the tables
      become tabs — one component at a time. One table, or tables with no
      heading cell, are left as they are.

   2. What it saves. Reads #rs-pdp-data (rendered by sections/product-story)
      and, if the product has the figures, renders the same estimate the
      finder shows under a recommendation, from the same rates file
      (assets/rs-finder-savings.js, window.RS_SAVE). No product data lives
      here; the arithmetic is the finder's.
   =========================================================================== */
(function () {
  "use strict";

  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }

  /* ---- 1. specification tabs ------------------------------------------- */
  (function tabs() {
    var host = document.getElementById("rs-spec-tabs");
    var spec = document.querySelector("#rs-spec .spec");
    if (!host || !spec) { return; }
    var tables = Array.prototype.slice.call(spec.querySelectorAll("table"));
    if (tables.length < 2) { return; }

    /* A generic header ("Specification") names nothing. The first such table
       is the product itself, so it takes the product's noun; any later one
       falls back to a count. */
    var root = document.getElementById("rs-pdp");
    var track = root ? root.getAttribute("data-track") : "";
    var esL = (document.documentElement.getAttribute("lang") || "").toLowerCase().indexOf("es") === 0;
    var self = esL
      ? (track === "system" ? "El sistema" : ((track === "well" || track === "pool") ? "La bomba" : "Este producto"))
      : (track === "system" ? "The system" : ((track === "well" || track === "pool") ? "The pump" : "This product"));
    var usedSelf = false;
    var names = tables.map(function (t, i) {
      var first = t.querySelector("th") || t.querySelector("td");
      var name = first ? first.textContent.replace(/\s+/g, " ").trim() : "";
      if (!name || /^(specification|specifications|details?|item|parameter|especificaci[oó]n|especificaciones|detalles?|par[aá]metros?)s?$/i.test(name)) {
        name = usedSelf ? (esL ? "Componente " : "Component ") + (i + 1) : self; usedSelf = true;
      }
      return name.length > 48 ? name.slice(0, 46) + "…" : name;
    });
    /* Only tab when every table has a name of its own. */
    var unique = {}; names.forEach(function (n) { unique[n] = 1; });
    if (Object.keys(unique).length !== names.length) { return; }

    var btns = names.map(function (n, i) {
      var b = document.createElement("button");
      b.type = "button"; b.setAttribute("role", "tab"); b.textContent = n;
      b.addEventListener("click", function () { show(i); });
      host.appendChild(b); return b;
    });
    host.setAttribute("role", "tablist");
    host.hidden = false;

    function show(i) {
      tables.forEach(function (t, k) { t.classList.toggle("is-hidden", k !== i); });
      btns.forEach(function (b, k) { b.setAttribute("aria-selected", k === i ? "true" : "false"); });
    }
    show(0);
  }());

  /* ---- 2. what it saves ------------------------------------------------- */
  (function savings() {
    var host = document.getElementById("rs-save");
    var node = document.getElementById("rs-pdp-data");
    var API = window.RS_SAVE;
    if (!host || !node || !API) { return; }
    /* The savings text (state incentives, assumptions) is English only; skip it on the Spanish locale. */
    if ((document.documentElement.getAttribute("lang") || "").toLowerCase().indexOf("es") === 0) { return; }
    var d;
    try { d = JSON.parse(node.textContent); } catch (e) { return; }
    if (!d || !d.canSave || !(d.price > 0)) { return; }

    /* The same mapping the finder makes from a result to a savings row. */
    var mode, item = { cost: d.price };
    if (d.track === "system") {
      if (d.kw == null && d.pvKw == null) { return; }
      mode = d.family === "gridtie" ? "gridHome" : (d.family === "offgrid" ? "offgrid" : "gridBackup");
      item.kw = d.pvKw != null ? d.pvKw : d.kw;
      item.kwh = d.kwh;
    } else if (d.track === "pool") {
      if (d.hp == null) { return; }
      mode = "pool"; item.kwh = API.poolKwh(d.hp);
    } else if (d.track === "well") {
      if (d.hp == null) { return; }
      mode = "farm"; item.kwh = API.pumpKwh(d.hp);
    } else { return; }

    var state = "TX";
    try { var saved = window.localStorage.getItem("rs-state"); if (saved && /^[A-Z]{2}$/.test(saved)) { state = saved; } } catch (e) { /* storage may be unavailable */ }

    function findState(code) {
      for (var i = 0; i < API.STATES.length; i++) { if (API.STATES[i][0] === code) { return API.STATES[i]; } }
      return API.STATES[0];
    }

    function render() {
      var st = findState(state);
      var res = API.compute(st, mode, item);
      var opts = "";
      for (var k = 0; k < API.STATES.length; k++) {
        opts += '<option value="' + API.STATES[k][0] + '"' + (API.STATES[k][0] === state ? " selected" : "") + ">" + esc(API.STATES[k][1]) + "</option>";
      }
      var inc = API.incentives(st, mode, item, res), live = [];
      for (var m = 0; m < inc.length; m++) { if (inc[m].tag === "yes" || inc[m].tag === "maybe") { live.push(inc[m]); } }
      var incHtml;
      if (live.length) {
        incHtml = '<ul class="save-inc">';
        for (var n = 0; n < Math.min(live.length, 3); n++) {
          incHtml += '<li><span class="inc-tag ' + (live[n].tag === "yes" ? "yes" : "maybe") + '">' + esc(live[n].tag) + "</span><span>" + esc(live[n].title) + "</span></li>";
        }
        incHtml += "</ul>";
      } else {
        incHtml = '<p class="save-none">No state programme we know of applies to this purchase in ' + esc(st[1]) + ". The figure above is what it earns on its own.</p>";
      }
      var as = API.assumptions(st, mode, item, res), asHtml = "";
      for (var q = 0; q < as.length; q++) { asHtml += "<li>" + as[q] + "</li>"; }

      var basisNote = (d.track === "system" && d.pvKw == null)
        ? " Generation is taken from the inverter rating because this listing publishes no array size."
        : "";

      host.innerHTML =
        '<div class="blk-head">' +
          '<span class="eyebrow">What it saves you</span>' +
          "<h2>An estimate you can check.</h2>" +
          "<p>This " + (d.track === "system" ? "system" : "pump") + ", priced against what you are paying now." + esc(basisNote) + "</p>" +
          '<label class="save-state">Where you are<select id="rs-state">' + opts + "</select></label>" +
        "</div>" +
        '<div class="blk-body">' +
          '<div class="save-stats">' +
            '<div class="stat lead"><span class="k">Saved per year</span><span class="v">' + API.usd(res.annual) + '</span><span class="sub">' + esc(res.basis) + "</span></div>" +
            '<div class="stat"><span class="k">Pays for itself in</span><span class="v">' + (res.payback > 0 ? res.payback.toFixed(1) + " yrs" : "—") + '</span><span class="sub">on ' + API.usd(res.cost) + " of equipment</span></div>" +
            '<div class="stat"><span class="k">Over ' + API.YEARS + ' years</span><span class="v">' + API.usd(res.lifetime) + '</span><span class="sub">' + Math.round(res.kwh).toLocaleString("en-US") + " kWh a year " + (res.util ? "offset" : "replaced") + "</span></div>" +
          "</div>" +
          '<div class="save-foot">' +
            "<div><h4>Incentives worth checking in " + esc(st[1]) + "</h4>" + incHtml + "</div>" +
            '<div class="save-fed"><b>No federal credit</b>The 30% federal residential credit ended 31 December 2025. Nothing above includes it. <a href="' + esc(d.taxUrl || "/pages/solar-tax-credit-2025") + '">What still applies in 2026 →</a></div>' +
          "</div>" +
          '<details class="assump"><summary>Assumptions behind these numbers</summary><ul>' + asHtml + "</ul></details>" +
          '<p class="save-legal">An estimate for comparison, not a quote or a guarantee — it depends on orientation, shading, weather, your tariff and how you use power. Verify programmes at DSIREUSA.org.</p>' +
        "</div>";
      host.hidden = false;

      var sel = document.getElementById("rs-state");
      if (sel) {
        sel.addEventListener("change", function () {
          state = this.value;
          try { window.localStorage.setItem("rs-state", state); } catch (e) { /* fine */ }
          render();
        });
      }
    }
    render();
  }());
}());
